import { axiosInstance } from '@/apis/base'
import config from '../../config.json'
import { snakeToCamelKeys } from '@/utils/object'

/**
 * Returns PDF assignment details for the given ID.
 *
 * @param {number} pdfAssignmentId
 * @return {Promise<any>}
 */
export function getPdfAssignment(pdfAssignmentId) {
  return axiosInstance
    .get(`${config.apiUrl}/pdf_assignments/load/?id=${pdfAssignmentId}`)
    .then(({ data }) => {
      return {
        ...snakeToCamelKeys(data.PdfAssignment),
        topics: data.topics,
      }
    })
}
